import FieldWithInputCheckboxes from './FieldWithInputCheckboxes'

export default FieldWithInputCheckboxes



// WEBPACK FOOTER //
// ./src/components/FieldWithInputCheckboxes/index.js